import { UtilityService } from '../../utils/utility.service';

/**
 * The Logger Utility Service
 *
 * This service is used by Logger Service for preparing logging message
 */
export class LoggerUtilService {
  /**
   * Returns file name and line number of logging
   *
   * @returns
   */
  static getCallerDetails(): { lineNumber: string; fileName: string } {
    try {
      throw new Error();
    } catch (err) {
      try {
        const stack = err instanceof Error ? err.stack : undefined;
        if (stack === undefined) {
          throw new Error('Stack trace unavailable', {
            cause: err
          });
        }
        const callerLine = stack.split('\n')[4].split('/');
        const fileLineNumber = callerLine[callerLine.length - 1]
          .replace(/[()]/g, '')
          .replace('at', '')
          .replace(' eval code', '')
          .trim()
          .split(':');
        return {
          fileName: fileLineNumber[0],
          lineNumber: fileLineNumber[1]
        };
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
        return {
          fileName: '',
          lineNumber: ''
        };
      }
    }
  }

  static serializedRecord(record: unknown): string {
    return JSON.stringify(this.makeSerializable(record, [], true));
  }

  private static makeSerializable(value: unknown, seen: Array<unknown>, isRoot: boolean = false): unknown {
    if (this.isErrorWithStack(value)) {
      const err = value as DOMException;
      return UtilityService.deepExtend({ code: err.code, message: err.message, stack: err.stack }, value);
    }
    if (typeof value !== 'object' || value === null) {
      return value;
    }
    if (!isRoot) {
      if (seen.indexOf(value) !== -1) {
        return '[Circular reference]';
      }
      seen.push(value);
    }
    const result = (Array.isArray(value) ? [] : {}) as Record<string, unknown>;
    for (const key of Object.keys(value)) {
      const child = (value as Record<string, unknown>)[key];
      if (typeof child !== 'function') {
        result[key] = this.makeSerializable(child, seen);
      }
    }
    return result;
  }

  static isErrorWithStack(value: unknown): boolean {
    const isError = value instanceof Error;
    let isErrorObject: boolean;
    try {
      isErrorObject = (typeof value === 'object' &&
                      !!Object.getOwnPropertyDescriptor(value, 'message') &&
                      !!Object.getOwnPropertyDescriptor(value, 'stack'));
    } catch {
      isErrorObject = false;
    }
    return isError || isErrorObject;
  }

  static getCopyWithoutCircularDependencies(fromObject: unknown, { seenObject }: { seenObject: Array<unknown> } ): unknown {
    if (typeof fromObject !== 'object' || fromObject === null) {
      return fromObject;
    }

    const isArray = Array.isArray(fromObject);
    const result: Record<string, unknown> | Array<unknown> = isArray ? [] : {};

    for (const [key, value] of Object.entries(fromObject as Record<string, unknown>)) {
      if (typeof value !== 'function') {
        if (!value || typeof value !== 'object') {
          (result as Record<string, unknown>)[key] = value;
        } else if (this.isErrorWithStack(value)) {
          (result as Record<string, unknown>)[key] = value.toString();
        } else if (seenObject.indexOf(value) === -1) {
          seenObject.push(value);
          (result as Record<string, unknown>)[key] = this.getCopyWithoutCircularDependencies(value, { seenObject });
        } else {
          (result as Record<string, unknown>)[key] = '[Circular reference]';
        }
      }
    }
    return result;
  }
}
